<style lang="scss">
// @import "@/dependencies.scss";
</style>

<template>
  <v-responsive :aspect-ratio="1280 / 800">
    <v-carousel :height="333" hide-delimiters continuous cycle show-arrows-on-hover>
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        :aspect-ratio="1280 / 1024"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
  </v-responsive>
</template>

<script setup>
const items = [
  {
    src: "/images/landing/kliendid.png",
  },
  {
    src: "/images/landing/broneeringud.png",
  },
  {
    src: "/images/landing/kalender.png",
  },
];
</script>